// import React from 'react'

import AboutSection from './components/about/AboutSection';
import CoreValues from './components/about/CoreValues';
import Hero from './components/about/Hero';
import Footer from './components/Footer';
import FAQ from './components/home/Faqs';
import PromoBanner from './components/home/PromoBanner';
import WhyChooseUs from './components/home/WhyChooseUs';

const About = () => {
  return (
    <div>
      <Hero />
      <AboutSection
        title="What we do"
        description="We provide a complete digital platform designed for property owners, managers, and residents. From managing houses and residents to instant payments, reporting, and announcements — everything is in one place for easier living and smarter ownership."
        image="/assets/images/about/what-we-do.png"
      />

      <AboutSection
        title="Mission"
        description="To empower property owners, managers, and residents with a seamless, digital-first platform that saves time, reduces hassle, and improves transparency."
        image="/assets/images/about/mission.png"
      />

      <AboutSection
        title="Vision"
        description="To become the most trusted solution for modern property and resident management worldwide."
        image="/assets/images/about/vision.png"
        reverse // this flips the layout (image on left, text on right)
      />
      <CoreValues />
      <WhyChooseUs />
      <PromoBanner />
      <FAQ />
      <Footer />
    </div>
  );
};

export default About;
